export const pricing = {
  "breadcrumb": "Prijzen",
  "title": "Eenvoudige en flexibele tarieven",
  "subtitle": "Een enkele commissie van 5%, betaald door wie u maar wilt.",
  "whoPays": {
    "title": "Wie betaalt de kosten?",
    "traveler": {
      "label": "Optie 1: De reiziger betaalt (Aanbevolen)",
      "description": "U ontvangt 100% van uw prijs. De reiziger voegt 5% servicekosten toe.",
      "badge": "Standaard"
    },
    "host": {
      "label": "Optie 2: De host betaalt (Pro)",
      "description": "U betaalt de 5%. Lagere prijs weergegeven voor de reiziger, ideaal voor bedrijven.",
      "badge": "Optie Pro"
    }
  },
  "guarantee": "Totale transparantie gegarandeerd",
  "perYear": "/jaar",
  "choose": "Kies",
  "popular": "Populairste",
  "plans": {
    "traveler": {
      "name": "Reiziger",
      "description": "Om de wereld te verkennen tegen lagere kosten",
      "price": "5%",
      "period": "commissie",
      "features": [
        "Toegang tot alle woningen",
        "Verlaagde servicekosten (5%)",
        "Verzekering inbegrepen",
        "Ondersteuning 7/7",
        "Geen verborgen kosten"
      ]
    },
    "host": {
      "name": "Gastheer",
      "description": "Om kosteloos te verhuren en te ruilen",
      "price": "0%",
      "period": "commissie",
      "features": [
        "0% commissie op uw inkomsten",
        "Toegang tot gratis ruilen tussen gastheren",
        "Badge \"Eerlijke Prijs\" beschikbaar",
        "Verhoogde zichtbaarheid",
        "Prioritaire ondersteuning"
      ]
    }
  },
  "fairPrice": {
    "title": "Programma Eerlijke Prijs",
    "description": "Speel het spel, verdien meer.",
    "benefit1": "Zichtbare badge 'Eerlijke Prijs'",
    "benefit2": "Prioriteit in de resultaten",
    "benefit3": "Bonus ruilpunten",
    "condition": "Bied een tarief aan dat minstens 10% goedkoper is dan op andere platforms."
  },
  "taxAdvantage": {
    "title": "Belastingvoordeel & Pro",
    "text": "De 5% kosten kunnen aftrekbaar zijn als u een bedrijf bent. Het 0% model vereenvoudigt de boekhouding voor particulieren. Raadpleeg uw accountant."
  },
  "hostExchange": {
    "title": "Gastheer-ruilsysteem",
    "description": "Ruil uw verdiende nachten voor gratis verblijven.",
    "free": "Gratis (0€)",
    "community": "Gereserveerd voor geverifieerde leden"
  },
  "comparison": {
    "title": "Waarom is het beter?",
    "subtitle": "Vergelijk en zie het verschil",
    "features": "Kosten",
    "airbnb": "Airbnb / Booking",
    "traveltrok": "DONKEY TRAVEL",
    "hostFees": "Gastheerkosten",
    "travelerFees": "Reizigerskosten",
    "exchange": "Gratis Ruil"
  },
  "testimonials": {
    "title": "Wat onze leden zeggen",
    "subtitle": "Word lid van een gemeenschap die de regels verandert",
    "badge": "Getuigenissen",
    "exchanges": "ruilen",
    "saved": "bespaard",
    "verifiedMembers": "+15 000 leden",
    "completedExchanges": "+50 000 reizen",
    "totalSaved": "0% commissie"
  },
  "faq": {
    "title": "Veelgestelde vragen",
    "subtitle": "Alles wat u moet weten over onze tarieven",
    "q1": {
      "question": "Kan ik op elk moment van plan veranderen?",
      "answer": "Ja, u kunt op elk moment upgraden. Het verschil wordt berekend naar rato van uw huidige abonnement."
    },
    "q2": {
      "question": "Zijn er extra kosten?",
      "answer": "Nee, geen verborgen kosten. De weergegeven prijs is de definitieve prijs die u per jaar betaalt. De ruilen zijn daarna volledig gratis."
    },
    "q3": {
      "question": "Wat als ik niet tevreden ben?",
      "answer": "We bieden een 30 dagen niet-goed-geld-terug garantie. Als u niet tevreden bent, betalen we u volledig terug."
    },
    "q4": {
      "question": "Hoe werkt de facturering?",
      "answer": "U wordt jaarlijks gefactureerd. U kunt betalen met creditcard of overschrijving. De facturering is automatisch en u ontvangt een factuur per e-mail."
    },
    "q5": {
      "question": "Kan ik mijn abonnement annuleren?",
      "answer": "Ja, u kunt op elk moment annuleren. Uw abonnement blijft actief tot het einde van de betaalde periode."
    }
  },
  "cta": {
    "title": "Klaar om het avontuur te beginnen?",
    "subtitle": "Sluit u aan bij duizenden eigenaars die gratis reizen",
    "createAccount": "Mijn account aanmaken",
    "exploreDestinations": "Bestemmingen verkennen"
  },
  "signup": {
    "title": "Maak uw account aan",
    "subtitle": "Word lid van onze eigenaarsgemeenschap",
    "firstName": "Voornaam",
    "lastName": "Achternaam",
    "email": "E-mail",
    "phone": "Telefoon",
    "country": "Land",
    "selectCountry": "Selecteer uw land",
    "plan": "Abonnement",
    "selectPlan": "Selecteer uw plan",
    "propertyType": "Type woning",
    "selectPropertyType": "Selecteer het type woning",
    "terms": "Ik ga akkoord met de voorwaarden en het privacybeleid",
    "submit": "Mijn account aanmaken",
    "success": "Account succesvol aangemaakt!",
    "error": "Er is een fout opgetreden. Probeer het opnieuw.",
    "securityNote": "Uw gegevens zijn veilig en worden nooit gedeeld",
    "house": "Huis",
    "apartment": "Appartement",
    "villa": "Villa",
    "loft": "Loft",
    "other": "Anders"
  },
  "signupSection": {
    "title": "Word vandaag nog lid van DONKEY TRAVEL",
    "subtitle": "Maak uw account in enkele minuten aan en begin uw woning te ruilen met eigenaars van over de hele wereld.",
    "verifiedMembers": "Geverifieerde leden",
    "verifiedMembersDesc": "Al onze leden zijn geverifieerde Airbnb-hosts voor ruilen in alle vertrouwen.",
    "guaranteedSavings": "Gegarandeerde besparingen",
    "guaranteedSavingsDesc": "Onze leden besparen gemiddeld 3.500€ per jaar op hun verblijfskosten.",
    "globalNetwork": "Wereldwijd netwerk",
    "globalNetworkDesc": "Toegang tot meer dan 15.000 woningen in 85 landen over de hele wereld.",
    "responsiveSupport": "Responsieve support",
    "responsiveSupportDesc": "Ons team is 7/7 beschikbaar om u te begeleiden bij uw uitwisselingen."
  },
  "testimonialItems": {
    "sophie": "Dankzij DONKEY TRAVEL heb ik Barcelona, Rome en Amsterdam bezocht zonder accommodatie te betalen. De gemeenschap is responsief en de ruilbesprekingen zijn eenvoudig.",
    "thomas": "Ik heb me aangesloten bij de lanceeraanbieding 2026: -50% het eerste jaar. De prijs is levenslang gegarandeerd voor de eerste 1000, en ik ruil overal in Europa.",
    "marie": "Ik heb eindelijk mijn eerste ruil in Europa gedaan, en alles verliep soepel van het eerste bericht tot aankomst. De profielverificatie helpt echt.",
    "pierre": "Voor onze woningen bespaart het overzicht ons tijd: advertenties, berichten en beschikbaarheid zijn duidelijk en gemakkelijk te beheren."
  }
};
